import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from "react-dom";
import Card from "../../components/Card";
import FullCalendar from '@fullcalendar/react';     // Must Go Before Plugins
import dayGridPlugin from '@fullcalendar/daygrid';  // Main Grid Plugin
import {CALENDAR_FILTER_OPTIONS} from "./constants";
import Header from "./components/Header";
import {format, startOfMonth, set} from "date-fns";
import axios from "axios";
import {toast} from "react-toastify";
import {DATE_FORMATS} from "../../constants/DateFormats";
import {getEventById, getEventNode, getEventTitle, parseEventData} from "./helpers/EventHelper";

const CalendarPage = (props) => {
    const calendarRef = useRef(null);

    const getCalendarApi = () => {
        return calendarRef.current.getApi();
    }

    const [currentDate, setCurrentDate]     = useState(startOfMonth(new Date()));
    const [typeFilter, setTypeFilter]       = useState(CALENDAR_FILTER_OPTIONS.all.value);
    const [jobTypeFilter, setJobTypeFilter] = useState('');
    const [userFilter, setUserFilter]       = useState('');
    const [events, setEvents]               = useState([]);

    useEffect(() => {
        load();
    }, [currentDate, typeFilter, jobTypeFilter, userFilter]);

    const load = () => {
        axios.get(route('web-api.calendar.event-data', {
            date:   format(currentDate, DATE_FORMATS.DB),
            typeFilter,
            jobTypeFilter,
            userFilter,
        }).toString())
            .then((response) => {
                if (!!response.data) {
                    setEvents(parseEventData(response.data));
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(<div>{"An error occurred"}</div>);
            });
    }

    const handlePrevClick = () => {
        let calendarApi = getCalendarApi();
        calendarApi.prev();
        setCurrentDate(calendarApi.getDate());
    }

    const handleNextClick = () => {
        let calendarApi = getCalendarApi();
        calendarApi.next();
        setCurrentDate(calendarApi.getDate());
    }

    const handleHover = (el, event) => {
        el.title = getEventTitle(getEventById(event.id, events));
    }

    const renderEvent = (event) => {
        return getEventNode(getEventById(event.event.id, events));
    }

    return (
        <div className={"calendar"}>
            <Card classes={"border-0"}>
                <Header
                    currentDate={currentDate}
                    typeFilter={typeFilter}
                    jobTypeFilter={jobTypeFilter}
                    userFilter={userFilter}
                    onPrevClick={() => handlePrevClick()}
                    onNextClick={() => handleNextClick()}
                    onTypeFilterChange={(value) => setTypeFilter(value)}
                    onJobTypeFilterChange={(value) => setJobTypeFilter(value)}
                    onUserFilterChange={(value) => setUserFilter(value)}
                    jobTypes={props.jobTypes}
                    users={props.users}
                />
                <div className={"calendar-body"}>
                    <FullCalendar
                        ref={calendarRef}
                        plugins={[ dayGridPlugin ]}
                        initialView="dayGridMonth"
                        headerToolbar={false}
                        initialDate={currentDate}
                        fixedWeekCount={false}
                        dayMaxEvents={5}
                        events={events}
                        displayEventTime={false}
                        height={"auto"}
                        eventContent={renderEvent}
                        dayPopoverFormat={(date) => {
                            let processedDate = new Date();
                            processedDate = set(processedDate, {
                                year:           date.date.year,
                                month:          date.date.month,
                                date:           date.date.day,
                                hours:          0,
                                minutes:        0,
                                seconds:        0,
                                milliseconds:   0,
                            });

                            return format(processedDate, DATE_FORMATS.DATE);
                        }}
                        eventMouseEnter={({el, event, jsEvent, view}) => handleHover(el, event)}
                        // Sunday=0, Monday=1, Tuesday=2, etc.
                        firstDay={1}
                    />
                </div>
            </Card>
        </div>
    );
}

export default CalendarPage;

const target = document.getElementById('calendar-page');
if (target) {
    ReactDOM.render(
        <CalendarPage
            jobTypes={JSON.parse(target.dataset.jobTypes)}
            users={JSON.parse(target.dataset.users)}
        />,
        target
    );
}
